import {GetHistoryYearsParams} from 'domain/usecases';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';
import {makeGetHistoryYears} from 'main/factories/usecases';
import {generateAvailableYears} from 'presentation/utils/generateAvailableYears';

export const getHistoryYears = async ({isShowCurrentYear, signal}: GetHistoryYearsParams) => {
	const {
		beneficiary: {dtAdesaoC},
	} = getCurrentAccountAdapter();

	try {
		const response = await makeGetHistoryYears().get({isShowCurrentYear, signal});

		if (!response) {
			return generateAvailableYears(dtAdesaoC);
		}

		const years = response.map(year => year.ano);
		return [...years].reverse();
	} catch (error) {
		return generateAvailableYears(dtAdesaoC);
	}
};
